export const VENDOR_ITEM_NOTES_MAX_LENGTH = 255;

export function clampVendorItemNotes(notes: string): string {
  return notes.slice(0, VENDOR_ITEM_NOTES_MAX_LENGTH);
}
